module.exports = __webpack_public_path__ + "./docs/img/ide.21fe95b1776b2673cfaedf952a35080f.svg";